<svelte:options accessors/>
<script lang="ts">
    import CircularProgress from "@smui/circular-progress";
    import {getCodModeloTasa, getFormatter} from "../../utils";
    import {IPriceResponse, IServiceResponse} from "../../interfaces";
    import {Cart, getCart} from "../../models/cart";
    import {onMount} from "svelte";
    import Dialog, {Actions, Content} from "@smui/dialog";
    import NauiButton from "../../naui/atoms/NauiButton.svelte";
    import {ManagerVehicles} from "../../models/manager-vehicles";

    const formatter = getFormatter();
    let selectedVehicle;
    let codModeloTasa;

    export let cart: Cart;

    export let loading: boolean = true;
    export let dialog: any = {
        open: false,
        message: ''
    }
    export let price: IPriceResponse;
    export let service: IServiceResponse;

    onMount(async () => {
        codModeloTasa = getCodModeloTasa(service);
        getCart().then(c => {
            cart = c;
        });
        const manager = ManagerVehicles.getInstance();
        manager.selected$.subscribe((next) => {
            selectedVehicle = next;
        });
    });

    function add() {
        if (cart) {
            cart.addService({
                item: {
                    id: service.pk,
                    name: service.nombre,
                    reference: service.cod_referencia,
                    type: service.tipo_dinissan,
                    codModeloTasa: codModeloTasa,
                    image: service.images?.length > 0 ? service.images[0].image : '',
                    vin: selectedVehicle?.vin ?? '',
                    route: ['', 'servicio', service.slug].join('/')
                },
                prevPrice: price.precio_total,
                price: price.precioNeto,
                flag: price?.porcDescuento > 0 ? `DCTO ${price.porcDescuento}%` : '',
                quantity: 1,
                city: {
                    id: '11001'
                }
            });
            cart.update().then(() => {
                dialog.open = true;
                dialog.message = 'El servicio ha sido agregado al carrito';
            }).catch(() => {
                dialog.open = true;
                dialog.message = 'Se presento un error agregando el servicio al carrito';
            });
        }
    }

    function closeDialog() {
        dialog.open = false;
        dialog.message = '';
    }
</script>
<div class="text-c mb-1 m:text-l m:mt-2">
    {#if loading}
        <div class="pr-1 pl-1">
            <CircularProgress style="height: 18px; width: 18px;" indeterminate/>
        </div>
    {:else if price}
        {#if price.porcDescuento}
            <small>Antes {formatter(price.precio_total)}</small>
        {/if}
        <div class="price">
            {formatter(price.precioNeto)}
        </div>
        <div class="btn accent" on:click={()=>add()}>
            AGREGAR
        </div>
    {:else}
        NO DISPONIBLE
    {/if}
</div>

<Dialog bind:open={dialog.open}
        scrimClickAction=""
        escapeKeyAction=""
        aria-describedby="mandatory-content">
    <Content id="mandatory-content">
        {dialog.message}
    </Content>
    <Actions>
        <div class="box sx-ii">
            <NauiButton caption="ACEPTAR"
                        color="accent"
                        mode="solid"
                        on:click={()=>closeDialog()}/>
        </div>
    </Actions>
</Dialog>